import styled, { css } from "styled-components";
import { type WidthProps, width } from "styled-system";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import * as Button from "../../../../../../../../common-deprecated/styles/v2/lexus/components/Button";
import * as Type from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";
import { ColoursWrapper } from "../../../common/extras/styles/AccentColours";
import * as ItemSliderStyles from "../../../../../../../../common-deprecated/styles/lexus/ItemSlider";
import * as CashPrice from "../../../common/price/styles/CashPrice";
import * as MonthlyPrice from "../../../common/price/styles/MonthlyPrice";
import { parseHexToRGB } from "../../../../../../../../common-deprecated/utils";
import { bodyStyle, type TextStyleType } from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Type";

export const Header = styled.div<{ hasBackground?: boolean; hasImage?: boolean }>`
    position: relative;
    margin-bottom: ${theme.space[2]}px;
    padding: ${theme.space[2]}px ${theme.space[3]}px 0;

    ${({ hasBackground }) =>
        hasBackground &&
        css`
            ${Checkbox} {
                right: ${theme.spacer}px;
                background-color: ${theme.colors.white};
            }
            ${ColoursWrapper} {
                padding-bottom: ${theme.space[3]}px;
            }
        `};
    ${({ hasImage }) =>
        hasImage &&
        css`
            margin-bottom: ${theme.space[3]}px;
            @media ${getBreakpoint("up", "md")} {
                display: flex;
                flex-direction: row;
            }
        `};

    html[dir="rtl"] & {
        ${({ hasBackground }) =>
            hasBackground &&
            css`
                ${Checkbox} {
                    left: ${theme.spacer}px;
                    right: auto;
                }
            `};
    }
`;

export const ContentWrapper = styled.div<{ isOpen?: boolean }>`
    padding: 0 ${theme.space[3]}px ${theme.space[3]}px;
    ${ItemSliderStyles.Wrapper} {
        margin-bottom: ${theme.space[3]}px;
        @media ${getBreakpoint("up", "lg")} {
            position: relative;
            left: 80px;
            max-width: calc(100% - 80px);
        }
    }

    html[dir="rtl"] & {
        ${ItemSliderStyles.Wrapper} {
            @media ${getBreakpoint("up", "lg")} {
                left: auto;
                right: 80px;
            }
        }
    }
`;

export const Wrapper = styled.div<{
    packIndex: number;
    disableBorder?: boolean;
    selected?: boolean;
    isSinglePack?: boolean;
}>`
    margin-bottom: ${theme.space[3]}px;
    background-color: ${theme.colors.white};
    border: 0;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.25);

    &:last-of-type {
        margin-bottom: 0;
    }

    ${({ packIndex, disableBorder }) =>
        packIndex === 0 &&
        !disableBorder &&
        css`
            border-top: 1px solid ${theme.colors.silver};
        `};

    ${({ selected }) =>
        selected &&
        css`
            box-shadow: 0 0 0 2px ${theme.colors.azure};
        `};

    ${({ disableBorder }) =>
        disableBorder &&
        css`
            box-shadow: 0 0 0 2px rgb(${parseHexToRGB(theme.colors.platinumLight).rgb});
        `};

    ${({ isSinglePack }) =>
        isSinglePack &&
        css`
            padding: 0;
            border: none;
            box-shadow: none;

            ${Header},
            ${ContentWrapper} {
                padding-left: 0;
                padding-right: 0;
            }
        `};
`;

export const Checkbox = styled.div``;

export const TitleWrapper = styled.div<{ hasImage: boolean }>`
    ${({ hasImage }) => css`
        ${hasImage &&
        css`
            @media ${getBreakpoint("up", "md")} {
                position: absolute;
                bottom: 25px;
                padding-left: ${theme.spacer}px;
            }
        `};
    `};

    /* Fix alignment title and tooltip icon */
    ${Type.Strong} {
        display: flex;
        align-items: center;
    }

    html[dir="rtl"] & {
        ${({ hasImage }) => css`
            ${hasImage &&
            css`
                @media ${getBreakpoint("up", "md")} {
                    padding-left: 0;
                    padding-right: ${theme.spacer}px;
                }
            `};
        `};
    }
`;

export const Title = styled.h2`
    font-family: ${theme.fonts.regular};
    font-size: 1.8rem;
    line-height: 2.43rem;
    text-align: start;
    text-transform: none;
`;

export const PriceWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: ${theme.space[1]}px;

    ${CashPrice.Text},
    ${MonthlyPrice.Text} {
        font-family: ${theme.fonts.regular};
        font-size: 1.4rem;
        letter-spacing: 1%;
        line-height: 2.43rem;
        color: ${theme.colors.platinumDark};
    }

    ${Button.ButtonWithIcon} {
        margin-left: ${theme.space[1]}px;
    }

    html[dir="rtl"] & {
        ${Button.ButtonWithIcon} {
            margin-left: 0;
            margin-right: ${theme.space[1]}px;
        }
    }
`;

export const Description = styled.div<WidthProps>`
    ${width};
`;

export const Footnote = styled.div<TextStyleType>`
    margin-bottom: ${theme.space[2]}px;
    padding: 0 ${theme.space[3]}px;
    color: ${theme.colors.platinumDark};
    ${bodyStyle};
`;

export const PackAction = styled.div<{ isActive?: boolean }>`
    display: flex;
    justify-content: space-between;
    padding: 0 ${theme.space[3]}px ${theme.space[4]}px;
`;

export const ImageWrapper = styled.div<{ src: any }>`
    width: 100%;
    height: 200px;
    background-image: url(${({ src }) => src && src});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
`;

export const OptionalContainer = styled.div`
    padding: ${theme.space[3]}px;
    background-color: ${theme.colors.mist};
`;

export const FooterTitle = styled.h2`
    margin: 0 0 ${theme.space[3]}px;
    font-family: ${theme.fonts.regular};
    font-size: 1.6rem;
    line-height: 2.4rem;
    text-transform: none;
    color: ${theme.colors.midnight};
`;

export const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: ${theme.space[4]}px;

    @media ${getBreakpoint("up", "sm")} {
        grid-template-columns: 1fr 1fr;
    }

    @media ${getBreakpoint("up", "xl")} {
        grid-template-columns: 1fr 1fr 1fr;
    }
`;
